import React, { useEffect, useRef, useState } from "react";
import { floorStats, Pills } from "./FloorHeader";

const num = (s) => { const m = /[-+]?\d+(\.\d+)?/.exec(String(s || "").replace(/,/g, "")); return m ? Number(m[0]) : null; };

const CountUp = ({ text }) => {
  const target = num(text);
  const [shown, setShown] = useState(text);
  const from = useRef(target);
  useEffect(() => {
    if (target == null || from.current == null || from.current === target) { setShown(text); from.current = target; return undefined; }
    const a = from.current, t0 = performance.now(), dp = (String(text).split(".")[1] || "").replace(/\D/g, "").length;
    let raf;
    const step = (t) => {
      const k = Math.min(1, (t - t0) / 900), v = a + (target - a) * (1 - (1 - k) ** 3);
      setShown(String(text).replace(/[-+]?[\d,]+(\.\d+)?/, `${v >= 0 && /^\+/.test(text) ? "+" : ""}${v.toFixed(dp)}`));
      if (k < 1) raf = requestAnimationFrame(step); else from.current = target;
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [text, target]);
  return <>{shown}</>;
};

const Spark = ({ pts, pos }) => {
  if (pts.length < 2) return <span className="inline-block w-[4.5em]" />;
  const lo = Math.min(...pts), hi = Math.max(...pts), s = hi - lo || 1;
  const d = pts.map((v, i) => `${(i / (pts.length - 1)) * 100},${28 - ((v - lo) / s) * 26}`).join(" ");
  return <svg viewBox="0 0 100 30" preserveAspectRatio="none" className="w-[4.5em] h-[1.6em]"><polyline points={d} fill="none" stroke={pos ? "#2CF6B3" : "#FF3D68"} strokeWidth="2" vectorEffect="non-scaling-stroke" /></svg>;
};

export const TvStats = ({ pnl, equity, live, gates, hidden }) => {
  const stats = floorStats(pnl, equity, hidden);
  const hist = useRef({});
  stats.forEach(([, v, , t]) => {
    const n = num(v), h = (hist.current[t] = hist.current[t] || []);
    if (n != null && h.at(-1) !== n) { h.push(n); if (h.length > 30) h.shift(); }
  });
  return (
    <header className="fc-panel fx-glow px-[1em] py-[0.6em] flex items-center gap-[1.6em]" data-testid="tv-stats-strip">
      <div className="flex-1 grid gap-[1.2em]" style={{ gridTemplateColumns: `repeat(${stats.length}, minmax(0, 1fr))` }}>
        {stats.map(([l, v, c, t]) => (
          <div key={t} className="min-w-0" data-testid={t}>
            <p className="fc-label">{l}</p>
            <div className="flex items-end gap-[0.5em]">
              <p className={`fc-num font-bold text-[2.1em] leading-none ${c}`}><CountUp text={v} /></p>
              <Spark pts={hist.current[t] || []} pos={!/fc-loss/.test(c)} />
            </div>
          </div>
        ))}
      </div>
      <div className="fx-pills flex flex-wrap gap-[0.4em] justify-end max-w-[34%]" data-testid="floor-status-pills"><Pills live={live} /></div>
    </header>
  );
};
